module.exports = __webpack_public_path__ + "static/media/footers@2x.dcc8cb13.jpg";